import axios from 'axios';
import { baseUrl } from '@/config';

const EVENT_HIST_URL = `${baseUrl}/event/event-hist`;
export default {
  /**
   * [이벤트>이벤트이력] 이벤트이력 정보 조회
   * @author najongdang
   * @param  {Object} params treeType 및 필터링 정보
   * @return {Map}        해당 위젯에 표현될 성능정보
   */
  getEventHistList(params) {
    return axios.post(`${EVENT_HIST_URL}/get-event-hist-list.do`, params);
  },
  /**
   * [이벤트>이벤트이력] 이벤트이력 차트 정보 조회
   * @author najongdang
   * @param  {Object} params treeType 및 필터링 정보
   * @return {Map}        해당 위젯에 표현될 성능정보
   */
  getEventHistChartData(params) {
    return axios.post(`${EVENT_HIST_URL}/get-event-hist-chart-data.do`, params);
  },

  getAutoReleaseHistInfo(params) {
    return axios.post(`${EVENT_HIST_URL}/get-auto-release-hist-info.do`, params);
  },
  /**
   * 이벤트 이력 엑셀 파일명을 조회한다.
   * @param  {[type]} params [description]
   * @return {[type]}        [description]
   * @author jda
   */
  getEventHistExcelName(params) {
    return axios.post(`${EVENT_HIST_URL}/get-event-hist-excel-name.do`, params);
  },
  /**
   * Root Cause 연관 관계 트리를 가져온다.
   * @param  {[type]} params [description]
   * @return {[type]}        [description]
   * @author na
   */
  getRootCauseChildList(rootId) {
    return axios.get(`${EVENT_HIST_URL}/get-root-cause-tree.do`, { params: { rootId } });
  },
  /**
   * 예외 이벤트 이력을 조회한다.
   * @param  {[type]} params [description]
   * @return {[type]}        [description]
   * @author na
   */
  getRootCauseEventExceptList(params) {
    return axios.post(`${EVENT_HIST_URL}/get-root-cause-event-except-list.do`, params);
  },
  /**
   * 예외 알람 이력을 조회한다.
   * @param  {[type]} params [description]
   * @return {[type]}        [description]
   * @author na
   */
  getRootCauseAlarmExceptList(params) {
    return axios.post(`${EVENT_HIST_URL}/get-root-cause-alarm-except-list.do`, params);
  },
  /**
   * 이벤트 등급 별 이벤트 이력 통계 데이터를 조회한다.
   * @param  {[type]} params [description]
   * @return {[type]}        [description]
   * @author na
   */
  getEventHistStatsGroupByEventlevel(params) {
    return axios.post(`${EVENT_HIST_URL}/get-event-hist-count-by-eventlevel.do`, params);
  },
  /**
   * 관리 구분(obj_define) 별 이벤트 이력 통계 데이터를 조회한다.
   * @param  {[type]} params [description]
   * @return {[type]}        [description]
   * @author na
   */
  getEventHistStatsGroupByObjDefine(params) {
    return axios.post(`${EVENT_HIST_URL}/get-event-hist-count-by-obj-define.do`, params);
  },
  /**
   * 장비 별 이벤트 이력 TopN 이벤트 등급 통계를 조회한다.
   * @param  {[type]} params [description]
   * @return {[type]}        [description]
   * @author na
   */
  getEventHistStatsGroupByObjTopN(params) {
    return axios.post(`${EVENT_HIST_URL}/get-event-hist-count-by-obj-top-n.do`, params);
  },
  /**
   * seqNumber에 대한 이벤트 이력 정보를 조회한다.
   * @author Ju
   * @param  {Number} seqNumber 이벤트 이력 seqNumber
   * @return {[type]}           [description]
   */
  getEventHistBySeqNumber(seqNumber) {
    return axios.get(`${EVENT_HIST_URL}/get-event-hist-by-seq-number.do`, { params: { seqNumber } });
  },
  /**
   * 특정 관리 대상의 조건 기간 내에 발생한 이벤트 이력 정보를 조회한다.
   * @author Ju
   * @param {Object} 파라미터 객체 (objId, startDatetime, endDatetime, 헤더 테이블 검색 조건)
   * @return {[type]}               [description]
   */
  getEventHistByObjAndPeriod(params) {
    return axios.post(`${EVENT_HIST_URL}/get-event-hist-by-obj-id-and-period.do`, params);
  },
  /**
   * 이벤트 이력에 대한 장애 분석 정보를 반환한다.
   * @author Ju
   * @param  {Number} seqNumber 이벤트 이력 seqNumber
   * @param  {Number}  objId     관리 대상 아이디 (option)
   * @return {Boolean}           [description]
   */
  getFaultAnalysisInfoOfEventHist(seqNumber, objId) {
    return axios.get(`${EVENT_HIST_URL}/get-fault-analysis-info-of-event-hist.do`, { params: { seqNumber, objId } });
  },
  /**
   * 이벤트 이력에 대한 장애 분석 정보를 반환한다.
   * @author Ju
   * @param  {Number} seqNumber 이벤트 이력 seqNumber
   * @return {Boolean}           [description]
   */
  getFaultAnalysisEventTimeline(seqNumber) {
    return axios.get(`${EVENT_HIST_URL}/get-fault-analysis-event-timeline.do`, { params: { seqNumber } });
  },
  /**
   * [장애 분석] 연관 이벤트 이력 목록을 반환한다. (페이징 처리 X)
   * @author Ju
   * @param  {Object}  params  (objIds, startDatetime, endDatetime)
   * @return {Boolean}        [description]
   */
  getFaultAnalysisEventHist(params) {
    return axios.post(`${EVENT_HIST_URL}/get-fault-analysis-event-hist.do`, params);
  },
};



// WEBPACK FOOTER //
// ./src/api/event/event-hist.js